import { ComponentChildren } from "preact";

export function ButtonCTA(
  props: { children: ComponentChildren; href: string },
) {
  return <a class="cta-button themed" href={props.href}>{props.children}</a>;
}
